import React, { useMemo } from 'react';

import type { GamesByClubs } from '@swf/core/types/Poker';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';
import { Image, PokerGameTile } from '@swf/poker';

import DeleteGameButton from '../PokerGameTile/DeleteGame/DeleteGameButton';

import styles from './PokerGameTileContainer.scss';

export interface Props {
  games: GamesByClubs;
  clubs: HgClubInfo[];
}

const PokerGameTileContainer: React.FC<Props> = ({ games, clubs }) =>
  useMemo(
    () => (
      <section className={styles.container}>
        {Object.entries(games).map(([clubId, games]) => {
          const club = clubs.find((club) => club.clubId && club.clubId === Number(clubId));
          const hasGames = games.find(({ clubId }) => clubId === club?.clubId);

          return (
            <div className={styles.gamesOuterContainer} key={clubId}>
              {hasGames && (
                <div className={styles.title}>
                  <div className={styles.clubAvatar}>
                    <Image className={styles.avatar} imageByteArray={club?.clubImage} />
                  </div>
                  <p>{club?.clubName}</p>
                  <DeleteGameButton games={games} clubId={Number(club?.clubId)} />
                </div>
              )}
              <div
                className={styles.gamesInnerContainer}
                data-testid={`${club?.clubName}-game-container`}
              >
                {games.map((game) => (
                  <PokerGameTile key={game.id} {...game} data-testid="game-item" />
                ))}
              </div>
            </div>
          );
        })}
      </section>
    ),
    [games, clubs]
  );

export default PokerGameTileContainer;
